export default "__VITE_ASSET__DzJebiHe__"